import { graphql } from 'react-relay';

export const TaskConnectionFragment = graphql`
    fragment TaskConnectionFragment on TaskConnection {
        edges {
            cursor
            node {
                ...TaskFragment
                ...TaskFragmentStatus
                ...TaskFragmentType
                ...TaskFragmentScheduleItem
            }
        }
        structure {
            ...StructureFragment
        }
        pageInfo {
            ...PageInfoFragment
        }
    }
`;
